import {ReactNode} from 'react';

import {Text} from '../../../ui';
import css from '../styles/authenticationTiltes.module.css';

interface IAuthenticationTitlesProps {
  mainTitle: string | ReactNode;
  subTitle: string | ReactNode;
}

const AuthenticationTitles = ({
  mainTitle,
  subTitle,
}: IAuthenticationTitlesProps) => {
  return (
    <div className={css.header}>
      <div className={css.headingWrapper}>
        <div className={css.header}>
          <Text
            color={Text.COLOR.PRIMARY}
            fontFamily={Text.FONT_FAMILY.RUBIK}
            fontSize={Text.FONT_SIZE.SIZE_32}
            fontWeight={Text.FONT_WEIGHT.MEDIUM}
            lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_6}
          >
            {mainTitle}
          </Text>
        </div>
        <div className={css.subtitle}>
          <Text
            fontSize={Text.FONT_SIZE.SIZE_18}
            color={Text.COLOR.GREY}
            lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_4}
          >
            {subTitle}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default AuthenticationTitles;

AuthenticationTitles.defaultProps = {
  mainTitle: '',
  subTitle: '',
};
